import { createFileRoute } from '@tanstack/react-router'
import { AdminAutomations } from '@/components/admin/marketing/AdminAutomations'

export const Route = createFileRoute('/admin/marketing/automations')({
  component: () => <AdminAutomations />,
})
